import { render, staticRenderFns } from "./TemplateCharacterItem.vue?vue&type=template&id=35c7c080&scoped=true"
import script from "./TemplateCharacterItem.vue?vue&type=script&lang=js"
export * from "./TemplateCharacterItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateCharacterItem.vue?vue&type=style&index=0&id=35c7c080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7c080",
  null
  
)

export default component.exports